module.exports = __webpack_public_path__ + "img/pectoral_man.99ca07a6.png";